import { lazier } from '@shared/components';

export const DashboardPage = lazier(() => import('./DashboardPage'));
